// gloss
export const resolveHttpUrl = (value: string | null | undefined, base?: string): string | null => {
  if (!value) return null;
  try {
    const parsed = new URL(value, base);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : null;
  } catch {
    return null;
  }
};

// gloss
export const isHttpUrl = (value: string | null | undefined): boolean => resolveHttpUrl(value) !== null;
